import { ComponentType, FC, PropsWithChildren, PureComponent, ReactNode, createContext, useEffect, useState } from "react";
import FeatureFlagService from "./featureFlagService";
import Features from "./features";

export interface FeatureFlagContextProps {
    enabledFeatureFlags: Set<string>;
}

export const FeatureFlagContext = createContext<FeatureFlagContextProps>({
  enabledFeatureFlags: new Set<string>(), 
});

export const FeatureFlagContextProvider: FC<{ children: ReactNode }> = (props: { children: ReactNode }) => {
    const [enabledFeatureFlags, setEnabledFeatureFlags] = useState(new Set<Features>());

    useEffect(() => {
        const featureFlagService = new FeatureFlagService();
        featureFlagService.getAllEnabledFeatures().then((allEnabledFlags) => {
            setEnabledFeatureFlags(allEnabledFlags);
        });
    }, []);

    return (
        <FeatureFlagContext.Provider
            value={{ enabledFeatureFlags }}
        >
            {props.children}
        </FeatureFlagContext.Provider>
    )
}

export function withFeatureFlagContext<T>(Component: ComponentType<PropsWithChildren<T & FeatureFlagContextProps>>): ComponentType<PropsWithChildren<T>> {
    class WithFeatureFlagContext extends PureComponent<T> {
        public render() {
            return (
                <FeatureFlagContext.Consumer>
                    {({ enabledFeatureFlags }) => <Component {...this.props} enabledFeatureFlags={enabledFeatureFlags} />}
                </FeatureFlagContext.Consumer>
            );
        }
    }

    return WithFeatureFlagContext;
}
